import React from "react";
import { Typography, Box } from "@mui/material";
import { FCard } from "@ui/components/card";
import { SecondaryGrid } from "@ui/components/grid";
import { temperatureLogData as defaultData } from "./data";
import { useTranslation } from "react-i18next";
import { formatUtcToLocalDateTimeString } from "@application/common/helpers/date-util";
const formatFatDuration = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h > 0 && m > 0)
        return `${h}h ${m}m`;
    if (h > 0)
        return `${h}h`;
    return `${m}m`;
};
export const TemperatureLog = ({ title = "Temperature Log", data = defaultData, loading = false, rowCount = 0, paginationModel = { page: 0, pageSize: 25 }, onPaginationModelChange, pageSizeOptions = [25, 50], }) => {
    const { t } = useTranslation("common");
    const hasFatDuration = data.some((row) => row.fatDuration != null);
    const temperatureLogColumns = [
        {
            field: "dateTime",
            headerName: t("grid.dateTime"),
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatUtcToLocalDateTimeString(params.row.dateTime),
        },
        {
            field: "temperature",
            headerName: t("grid.temperature"),
            flex: 1,
            minWidth: 120,
        },
        ...(hasFatDuration
            ? [
                {
                    field: "fatDuration",
                    headerName: "Fat Hours",
                    flex: 0.8,
                    minWidth: 90,
                    renderCell: (params) => {
                        const val = params.row.fatDuration;
                        return val != null ? formatFatDuration(val) : "—";
                    },
                },
            ]
            : []),
    ];
    return (React.createElement(FCard, null,
        React.createElement(Box, { pt: 1.5, px: 1.5 },
            React.createElement(Typography, { variant: "h6" }, title),
            React.createElement(SecondaryGrid, { rows: data, columns: temperatureLogColumns, paginationMode: "server", loading: loading, rowCount: rowCount, paginationModel: paginationModel, onPaginationModelChange: onPaginationModelChange, pageSizeOptions: pageSizeOptions, fillRemainingSpace: false, useAutoHeight: false, gridMaxHeight: 450, headerBackgroundColor: "#F4F6F8" }))));
};
